import styled from '@themes/theme'

export const TutorialWrap = styled.div`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  width: 100%;
  .cls-x-btn {
    width: 20px;
    height: 20px;
    margin: 0 12% 5px 0;
    .x-ico {
      position: relative;
      display:block;
      width: 100%;
      height: 100%;
      transform: rotate(45deg);
      &::before, &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: ${props => props.theme.color.themeTxt};
      }
      &::before {
        width: 1px;
        height: 100%;
      }
      &::after {
        width: 100%;
        height: 1px;
      }
    }
  }
  .swiper-container-fade {
    &.swiper-container-free-mode {
      .swiper-slide {
        transition-timing-function: ease-out;
      }
    }
    .swiper-slide {
      pointer-events: none;
      transition-property: opacity;
      .swiper-slide {
        pointer-events: none;
      }
    }
    .swiper-slide-active {
      &,
      & .swiper-slide-active {
        pointer-events: auto;
      }
    }
  }
  .swiper {
    padding-bottom: 60px;
    .swiper-button-prev, .swiper-button-next {
      width: 60px;
      height: 60px;
      margin-top: -60px;
      &::before, &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 1px;
        height: 50%;
        background: ${props => props.theme.color.themeTxt};
      }
      &::before {
        transform: translate(-50%, -90%) rotate(45deg);
      }
      &::after {
        transform: translate(-50%, -20%) rotate(-45deg);
      }
    }
    .swiper-button-next {
      transform: rotate(180deg);
    }
    .swiper-wrapper {
      .swiper-slide {
        position: relative;
        .img {
          width: 100%;
          transform: translate3d(0, 0, 0);
        }
        .cls-btn {
          display: none;
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 40px;
        }
        &.swiper-slide-active {
          .cls-btn {
            display: block;
          }
        }
      }
    }
  }
  &.tutorial-pc{
    width: 600px;
    .cls-x-btn {
      width: 30px;
      height: 30px;
    }
  }

  &.baccarat-guide {
    width: 380px;
    .cls-x-btn {
      z-index: 2;
      position: absolute;
      top: 21px;
      right: 10px;
    }
    .swiper {
      padding-bottom: 0;
      .swiper-button-disabled {
        opacity: .1;
      }
      .swiper-button-prev {
        left: -5px;
      }
      .swiper-button-next {
        right: -5px;
      }
    }
  }
  &.baccarat-guide-pc {
    width: 550px;
    .cls-x-btn {
      width: 30px;
      height: 30px;
      top: 30px;
      right: 15px;
    }
    .swiper {
      .swiper-button-disabled {
        opacity: .1;
      }
      .swiper-button-prev, .swiper-button-next {
        margin-top: -30px;
      }
      .swiper-button-prev {
        left: -5px;
      }
      .swiper-button-next {
        right: -5px;
      }
    }
  }
`
